export default function CRMAttachmentIco() {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="48" rx="7.5" fill="#EBE1F9" />
      <path
        d="M12 18.9327C12 17.4392 12 16.6925 12.2907 16.122C12.5463 15.6203 12.9543 15.2123 13.456 14.9567C14.0265 14.666 14.7732 14.666 16.2667 14.666H20.8994C21.5516 14.666 21.8777 14.666 22.1847 14.7397C22.4567 14.805 22.7168 14.9128 22.9555 15.059C23.2245 15.2239 23.4552 15.4545 23.9164 15.9157L24.0836 16.083C24.5448 16.5442 24.7755 16.7748 25.0445 16.9397C25.2832 17.0859 25.5433 17.1937 25.8153 17.259C26.1223 17.3327 26.4484 17.3327 27.1007 17.3327H31.7333C33.2268 17.3327 33.9736 17.3327 34.544 17.6233C35.0457 17.879 35.4537 18.2869 35.7093 18.7887C36 19.3591 36 20.1059 36 21.5993V29.066C36 30.5595 36 31.3063 35.7093 31.8767C35.4537 32.3784 35.0457 32.7864 34.544 33.042C33.9736 33.3327 33.2268 33.3327 31.7333 33.3327H16.2667C14.7732 33.3327 14.0265 33.3327 13.456 33.042C12.9543 32.7864 12.5463 32.3784 12.2907 31.8767C12 31.3063 12 30.5595 12 29.066V18.9327Z"
        stroke="#7F56D9"
        stroke-width="2.90909"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
